import dayjs from "dayjs";

export function getFallbackRange() {
  const isBeginningOfMonth = dayjs().date() <= 8;
  let start;
  let end;

  if (isBeginningOfMonth) {
    start = dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD");
    end = dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD");
  }

  if (!isBeginningOfMonth) {
    start = dayjs().startOf("month").format("YYYY-MM-DD");
    end = dayjs().subtract(1, "day").format("YYYY-MM-DD");
  }

  return {
    start,
    end,
  };
}
